import { ADSTERRA } from "@/ads/adsterraConfig";

const KEY = "ah_popunder_last";
const cooldownMs = () => ADSTERRA.popunderCooldownMin * 60_000;
export const popunderInCooldown = () => Date.now() - Number(localStorage.getItem(KEY) || 0) < cooldownMs();
const markFired = () => localStorage.setItem(KEY, String(Date.now()));

let installed = false;

// Blocks popunder/redirect windows during the cooldown; starts the cooldown when one fires.
export function installPopunderGuard() {
  if (installed) return;
  installed = true;

  const nativeOpen = window.open.bind(window);
  window.open = (...args) => {
    if (popunderInCooldown()) return null;
    const w = nativeOpen(...args);
    if (w) markFired();
    return w;
  };

  const nativeAnchorClick = HTMLAnchorElement.prototype.click;
  HTMLAnchorElement.prototype.click = function (...args) {
    const external = this.target === "_blank" && this.host && this.host !== window.location.host;
    if (external) {
      if (popunderInCooldown()) return undefined;
      markFired();
    }
    return nativeAnchorClick.apply(this, args);
  };

  let lastTap = 0;
  ["pointerdown", "touchstart", "click"].forEach((ev) =>
    window.addEventListener(ev, () => { lastTap = Date.now(); }, { capture: true, passive: true }));
  const onLeave = () => { if (Date.now() - lastTap < 1500 && !popunderInCooldown()) markFired(); };
  document.addEventListener("visibilitychange", () => { if (document.hidden) onLeave(); });
}
